import YouTubeIcon from '@mui/icons-material/YouTube';
import { Box, Tooltip } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import {
  STATION_INDICATOR_BADGE_ICON_FONT_SIZE,
  StationIndicatorBadge,
  StationIndicatorBadgeSize,
} from './StationIndicatorBadge';
import { youtubeNativeStationTooltipMessage } from './station-messages';
import { MinimumStation, Station } from '@app/core/types/stations';

type YoutubeNativeStationIconSize = StationIndicatorBadgeSize;

interface YoutubeNativeStationIconProps {
  station?: Station | MinimumStation | null;
  size?: YoutubeNativeStationIconSize;
  sx?: SxProps<Theme>;
  iconSx?: SxProps<Theme>;
}

function isYoutubeNativeStation(station: Station | MinimumStation): station is Station {
  return 'youtubeNative' in station && station.youtubeNative;
}

/**
 * Renders a YouTube-native indicator icon when the station has the youtubeNative flag enabled.
 */
export function YoutubeNativeStationIcon({
  station,
  size = 'medium',
  sx,
  iconSx,
}: YoutubeNativeStationIconProps) {
  const { $t } = useIntl();

  if (!station || !isYoutubeNativeStation(station)) {
    return null;
  }

  return (
    <Tooltip title={$t(youtubeNativeStationTooltipMessage)}>
      <Box component="span" display="inline-flex" alignItems="center">
        <StationIndicatorBadge size={size} sx={sx}>
          <YouTubeIcon
            sx={
              [
                {
                  fontSize: STATION_INDICATOR_BADGE_ICON_FONT_SIZE[size],
                  color: 'text.secondary',
                },
                iconSx,
              ] as SxProps<Theme>
            }
          />
        </StationIndicatorBadge>
      </Box>
    </Tooltip>
  );
}
